export default __webpack_public_path__ + "static/media/user.a9136072.png";